const originalStatus = {
	INITIALIZED: 'Costing Requested',
	QUOTED: 'Costing done',
	OFFER_SENT: 'Offer sent',
	APPROVED: 'Approved',
	REJECTED: 'Rejected',
	ARCHIVE: 'Closed',
	REQUEST_FOR_REVISION: 'Recosted'
};

const costingTabInfo = {
	BUYER_DESIGN_PENDING: {
		filterApiFor: 'COSTING_LIST',
		listApiUrl: 'fetchAllQuoteRequest',
		filterStatus: 'PENDING,RUNNING',
		quoteCountApiUrl: 'BUYER_DESIGN',
		activeTabName: 'BUYER_DESIGN_PENDING'
	},
	BUYER_DESIGN_COMPLETED: {
		filterApiFor: 'COSTING_LIST',
		listApiUrl: 'fetchAllQuoteRequest',
		filterStatus: 'COMPLETED',
		quoteCountApiUrl: 'BUYER_DESIGN',
		activeTabName: 'BUYER_DESIGN_COMPLETED'
	},
	BUYER_DESIGN_ARCHIVE: {
		filterApiFor: 'COSTING_LIST',
		listApiUrl: 'fetchAllQuoteRequest',
		filterStatus: 'ARCHIVE',
		quoteCountApiUrl: 'BUYER_DESIGN',
		activeTabName: 'BUYER_DESIGN_ARCHIVE'
	},
	DESIGN_STUDIO_PENDING: {
		filterApiFor: 'COSTING_LIST_STYLE_VIEW',
		listApiUrl: 'fetchInitialCostingDesignsList',
		filterStatus: 'PENDING',
		quoteCountApiUrl: 'DESIGN_STUDIO',
		activeTabName: 'DESIGN_STUDIO_PENDING'
	},
	DESIGN_STUDIO_IN_REVIEW: {
		filterApiFor: 'COSTING_LIST_STYLE_VIEW',
		listApiUrl: 'fetchInitialCostingDesignsList',
		filterStatus: 'UNDER_REVIEW',
		quoteCountApiUrl: 'BUYER_DESIGN',
		activeTabName: 'DESIGN_STUDIO_IN_REVIEW'
	},
	DESIGN_STUDIO_COMPLETED: {
		filterApiFor: 'COSTING_LIST_STYLE_VIEW',
		listApiUrl: 'fetchInitialCostingDesignsList',
		filterStatus: 'COMPLETED',
		quoteCountApiUrl: 'BUYER_DESIGN',
		activeTabName: 'DESIGN_STUDIO_COMPLETED'
	},
	COLLECTION_VIEW_PENDING: {
		filterApiFor: 'INITIAL_COSTING_LIST',
		listApiUrl: 'fetchCostingRequest',
		filterStatus: 'REQUESTED',
		quoteCountApiUrl: 'DESIGN_STUDIO',
		activeTabName: 'COLLECTION_VIEW_PENDING'
	},
	COLLECTION_VIEW_COMPLETED: {
		filterApiFor: 'INITIAL_COSTING_LIST',
		listApiUrl: 'fetchCostingRequest',
		filterStatus: 'COMPLETED',
		quoteCountApiUrl: 'DESIGN_STUDIO',
		activeTabName: 'COLLECTION_VIEW_COMPLETED'
	}
};

export { originalStatus, costingTabInfo };
